import React from "react";

const About = () => {
  return (
    <div name="about" className="w-full h-screen bg-[#0a192f] text-gray-300 ">
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className="max-w-[1000px] w-full  grid grid-cols-2 gap-8">
          <div className="sm:text-right pb-8 pl-4">
            <p className="text-4xl font-bold inline border-b-4 border-[#008037]">
              About
            </p>
          </div>
          <div></div>
        </div>
        <div className="max-w-[1000px] w-full  grid sm:grid-cols-2 gap-8 px-4">
          <div className="sm:text-right sm:text-3xl text-2xl font-bold ">
            <p>
              Welcome to my page.
              <br /> Lay back in your comfortable chair while You taking around
              . <br /> I hope you'll enjoy.
            </p>
          </div>
          <div>
            I'm passionate to build amazing web-applications that allows us to
            feel more comfortable in this life. I always attempt to bring some
            artistical approach to my job by doing it well and in special way.
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
